import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import "react-responsive-carousel/lib/styles/carousel.min.css";
import IMG1 from '../images/MaasaiMara.jpg';
import IMG2 from '../images/ambo.jpg';
import IMG3 from '../images/diani.jpg';
import IMG4 from '../images/wild.jpeg';
import IMG5 from '../images/baboons.jpeg';
import IMG6 from '../images/chasing.webp';

const sliderImages = [
  { src: IMG1, alt: 'Maasai Mara' },
  { src: IMG2, alt: 'Amboseli National Park' },
  { src: IMG3, alt: 'Diani Beach' }
];

const animatedImages = [
  { src: IMG4, alt: 'Wildlife', style: { top: 20, left: -40, zIndex: 3 }, animate: { y: [0, 30, 0], rotate: [0, 8, -8, 0] } },
  { src: IMG5, alt: 'Baboons', style: { top: 180, left: -60, zIndex: 2 }, animate: { x: [0, 40, -40, 0], scale: [1, 1.1, 1, 1.05, 1] } },
  { src: IMG6, alt: 'Chasing Herd', style: { bottom: 10, left: 40, zIndex: 1 }, animate: { y: [0, -20, 20, 0], scale: [1, 1.08, 1, 1.04, 1] } }
];

const HeroSection = () => {
  const navigate = useNavigate(); // Initialize navigate

  const openWhatsApp = (message) => {
    const phoneNumber = '+254792400119';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section className="bg-kenya-orange position-relative py-5 overflow-hidden" style={{ minHeight: 400 }}>
      {/* Decorative Circles */}
      <div style={{
        position: 'absolute', top: 40, left: 40, width: 100, height: 100,
        background: 'rgba(255,255,255,0.25)', borderRadius: '50%', zIndex: 1
      }} />
      <div style={{
        position: 'absolute', top: 120, right: 120, width: 70, height: 70,
        background: 'rgba(255,255,255,0.15)', borderRadius: '50%', zIndex: 1
      }} />
      <div style={{
        position: 'absolute', bottom: 60, left: '35%', width: 120, height: 120,
        background: 'rgba(255,255,255,0.18)', borderRadius: '50%', zIndex: 1
      }} />

      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row align-items-center" style={{ minHeight: 320 }}>
          {/* Left: Animated Images + Text */}
          <div className="col-lg-6 col-md-7 mb-4 mb-lg-0 position-relative" style={{ minHeight: 320 }}>
            {/* Animated Images */}
            {animatedImages.map((img, idx) => (
              <motion.img
                key={img.alt}
                src={img.src}
                alt={img.alt}
                initial={{ opacity: 0, ...img.style }}
                animate={{ opacity: 1, ...img.animate }}
                transition={{
                  duration: 4 + idx,
                  repeat: Infinity,
                  repeatType: "loop",
                  ease: "easeInOut"
                }}
                style={{
                  position: 'absolute',
                  width: 180 + idx * 40,
                  borderRadius: 16,
                  boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
                  ...img.style
                }}
              />
            ))}
            {/* Text Content */}
            <div style={{ position: 'relative', zIndex: 5 }}>
              <h1 className="display-3 fw-bold text-white mb-3">
                Experience the Magic of Kenya
              </h1>
              <p className="lead text-kenya-yellow mb-4">
                Breathtaking tours and safaris across Kenya's most beautiful destinations
              </p>
              <div className="d-flex flex-column flex-sm-row gap-3">
                <button
                  className="btn btn-light text-kenya-orange fw-semibold px-4 py-2 shadow mb-2 mb-sm-0 me-sm-3"
                  onClick={() => openWhatsApp('Hello, I would like to book a safari with you.')}
                >
                  Book Your Safari
                </button>
                <button
                  className="btn btn-outline-light fw-semibold px-4 py-2"
                  onClick={() => navigate('/services')} // Navigate to Services page
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
          {/* Right: Animated Carousel */}
          <div className="col-lg-6 col-md-5">
            <Carousel
              autoPlay
              infiniteLoop
              showThumbs={false}
              showStatus={false}
              showIndicators={true}
              interval={3000}
              transitionTime={900}
              emulateTouch
              className="rounded-4 shadow-lg"
            >
              {sliderImages.map((img) => (
                <div key={img.alt}>
                  <img
                    src={img.src}
                    alt={img.alt}
                    style={{
                      height: 320,
                      objectFit: 'cover',
                      borderRadius: '1.5rem'
                    }}
                  />
                  <p className="legend bg-kenya-orange text-white rounded-3 shadow" style={{ opacity: 0.95 }}>
                    {img.alt}
                  </p>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
      {/* Responsive adjustments */}
      <style>
        {`
          @media (max-width: 991.98px) {
            .carousel .slide img {
              height: 220px !important;
            }
          }
          @media (max-width: 767.98px) {
            .carousel .slide img {
              height: 160px !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default HeroSection;
